import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FavoritesService {
    protected backendBaseUrl: string = this.config.backendIwmUri;

    public isFavoritesAvailable: boolean = false;

    constructor(
        private http: HttpClient,
        private config: AppConfig) { }

    public addFavorite(apiUrl: string) {
        const url = `${this.backendBaseUrl}${apiUrl}`;
        return this.http.post(url, {});
    }

    public deleteFavorite(apiUrl: string) {
        const url = `${this.backendBaseUrl}${apiUrl}`;
        return this.http.post(url, {},
            { observe: 'response' })
            .pipe(
                map((result) => {
                    return result.status === 204; // No Content
                }));
    }

}
